import Cookies from "js-cookie";

export const AUTH_TOKEN_KEY = "authToken";
export const getAuthToken = () => Cookies.get(AUTH_TOKEN_KEY) || null;

export function setAuthToken(token, { persistent = true } = {}) {
  if (!token) return clearAuthToken();
  Cookies.set(AUTH_TOKEN_KEY, token, {
    ...(persistent ? { expires: 30 } : {}), sameSite: "strict",
    secure: window.location.protocol === "https:", path: "/"
  });
}

export function clearAuthToken() { Cookies.remove(AUTH_TOKEN_KEY, { path: "/" }); }
